import React from 'react';
import { useTheme } from 'styled-components';

interface Props {
  size?: number;
  color?: string;
  style?: React.CSSProperties;
  className?: string;
}

// Up-right diagonal arrow inside the "Visit link" pill on the frequency source cards
// (tabler:arrow-up, Figma node 15986:1417). Solid stroke (defaults to prussianBlue). Ticket 7127.
export const ArrowUpRightSvg: React.FC<Props> = ({ size = 16, color, style, className }) => {
  const { colors } = useTheme();
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      className={className}
    >
      <path
        d="M11.2998 4.69892L4.70014 11.2986M11.2998 10.3558L11.2998 4.69892L5.64295 4.69892"
        stroke={color ?? colors.prussianBlue}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
